export const ADMIN_SEARCH_OPTIONS = [
  { label: "Name", value: "search_key",default:true },
  { label: "Email", value: "search_key" },
];

export const CUSTOMER_SEARCH_OPTIONS = [
  { label: "Phone Number", value: "phone_number",default:true },
];

export const BOOKING_SEARCH_OPTIONS = [
  { label: "Phone Number", value: "primary_passenger_contact",default:true },
  { label: "Booking Id", value: "booking_id" },
];

export const OPERATOR_SEARCH_OPTIONS = [
  { label: "Phone Number", value: "phone_number",default:true },
];

export const BUS_SEARCH_OPTIONS = [
  { label: "Bus Number", value: "reg_no", default: true },
  { label: "Operator Phone number", value: "phone_number" },
];

export const SETTLEMENT_SEARCH_OPTIONS = [
  { label: "All", value: "all", default: true },
  { label: "Vehicle Number", value: "vehicle_number" },
  { label: "Operator Id", value: "operator_id" },
  { label: "Opertor Phone Number", value: "phone_number" },
];

export const TRANSACTION_SEARCH_OPTIONS = [
  { label: "Customer Name", value: "cutomer_name" },
  { label: "Customer Contact", value: "customer_contact", default: true },
];

export const REFFERAL_SEARCH_OPTIONS = [
  { label: "Phone Number", value: "referral_code", default: true },
];

export const REPORT_SEARCH_OPTIONS = [
  { label: "Bus Id / Number", value: "bus_id",default: true  },
];

export const CITY_SEARCH_OPTIONS = [{ label: "City Name", value: "cityName" }];

export const COUPON_SEARCH_OPTIONS = [
  { label: "Coupon Code", value: "coupan_code", default: true },
];

export const STAFF_SEARCH_OPTIONS = [
  { label: "Phone Number", value: "phone_number", default: true },
];

export const BUS_LIST_SEARCH_OPTIONS = [
  { label: "Travels Name", value: "travels_name", default: true },
];

export const POS_SEARCH_OPTIONS = [
  { label: "Bus Number", value: "bus_no", default: true },
  { label: "Phone Number", value: "phone_no" }
];

export const POS_BOOKING_SEARCH_OPTIONS = [
  { label: "Bus Id", value: "bus_id" },
  { label: "Ticket Id", value: "ticket_id", default: true }
];

export const ADVERTISEMENT_SEARCH_OPTIONS = [
  { label: "Title", value: "search_key",default: true  },
];

export const BONUS_SEARCH_OPTIONS = [
  { label: "Name / Value", value: "search_key",default: true  },
];
